module.exports = __webpack_public_path__ + "img/XG300.png";